import api from "../..";
import type { Ticket, TicketListItem, GetTicketParams, GetTicketsParams } from "./types";

export const getTickets = async ({ params }: GetTicketsParams = {}): Promise<TicketListItem[]> => {

  return await api.get("/tickets/", { params })
  .then(res => res.data)
  .catch(() => {return []});
};

export const getTicketById = async ({ id }: GetTicketParams): Promise<Ticket | null> => {

  return await api.get(`/tickets/${id}`)
  .then(res => res.data)
  .catch(() => {return null});
};